module.exports = __webpack_public_path__ + "media/dashboard/assets/images/priority_icons/high-15ea72fc0f78c8d8cbf572c0d5cc8f44.svg";